function defineProperty(object, name, value) {
    Object.defineProperty(object, name, {
        enumerable: true,
        value: value,
        writable: false,
    });
}

module.exports = {
    defineProperty: defineProperty,
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/ethers-utils/properties.js
// module id = 76
// module chunks = 0